import { render, staticRenderFns } from "./receiverJobStatistice.vue?vue&type=template&id=9a8e6d9a&scoped=true"
import script from "./receiverJobStatistice.vue?vue&type=script&lang=js"
export * from "./receiverJobStatistice.vue?vue&type=script&lang=js"
import style0 from "./receiverJobStatistice.vue?vue&type=style&index=0&id=9a8e6d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e6d9a",
  null
  
)

export default component.exports